import { useMutation } from '@tanstack/react-query';

import type { MutationConfig } from '@/lib/react-query';
import { api, extractData } from '@/lib/treaty';

type UploadFloorLayoutOptions = {
  mutationConfig?: MutationConfig<typeof uploadFloorLayouts>;
};

type UploadDocumentType = {
  layouts: FileList;
  projectId: string;
};

const uploadFloorLayouts = ({ layouts, projectId }: UploadDocumentType) => {
  return extractData(api.projects({ id: projectId }).layouts.batch.post({ layouts }));
};

export const useUploadFloorLayouts = ({ mutationConfig }: UploadFloorLayoutOptions = {}) => {
  return useMutation({
    ...mutationConfig,
    mutationFn: uploadFloorLayouts,
  });
};
